const isPopulatedObject = (value) => Boolean(value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length);

const normalizeUpdateRequestStatus = (status) => `${status || ''}`.trim().toLowerCase();

const isImportedUpdateRequestStatus = (status) => {
    const normalizedStatus = normalizeUpdateRequestStatus(status);
    return normalizedStatus === 'imported' || normalizedStatus === 'importedbybooker';
};

const isPendingSubmittedUpdateRequestStatus = (status) => normalizeUpdateRequestStatus(status) === 'submittedtobooker';

const parseExternalAccessData = (access) => {
    const payload = isPopulatedObject(access) ? access : null;
    const active = Boolean(payload);
    const email = payload?.Email || '';
    const activationDate = payload?.ActivationDate || '';
    return {
        exists: Boolean(payload),
        active,
        email,
        activationDate,
    };
};

const parseUpdateRequestData = (updateRequest) => {
    if (!isPopulatedObject(updateRequest)) {
        return null;
    }

    return {
        ...updateRequest,
        Status: updateRequest.Status || '',
    };
};

const parseExternalAccessResponse = (response) => {
    const hasNestedPayload =
        response &&
        typeof response === 'object' &&
        ('Access' in response || 'UpdateRequest' in response || 'access' in response || 'updateRequest' in response);
    const accessPayload = hasNestedPayload ? response.Access || response.access : response;
    const updateRequestPayload = hasNestedPayload ? response.UpdateRequest || response.updateRequest : null;

    return {
        access: parseExternalAccessData(accessPayload),
        updateRequest: parseUpdateRequestData(updateRequestPayload),
    };
};

const isExternalAccessEntityNotFoundError = (error) => {
    const errorCode = error?.errorCode || '';
    const message = error?.message || '';
    return `${errorCode}`.toLowerCase() === 'entitynotfound' || `${message}`.toLowerCase().includes('entitynotfound');
};

export {
    isExternalAccessEntityNotFoundError,
    isImportedUpdateRequestStatus,
    isPendingSubmittedUpdateRequestStatus,
    normalizeUpdateRequestStatus,
    parseExternalAccessResponse,
};
